<template>
	<div>
		<form id="add_user_form" @submit.prevent="add_user">
			<label><span>Adresse email&nbsp;:</span>
				<input type="email" name="email" placeholder="Adresse email" v-model="email_address" /></label><br />
			<label><span>Nom&nbsp;:</span>
				<input type="text" name="name" placeholder="Nom" v-model="name" /></label><br />
			<label><span>Mot de passe&nbsp;:</span>
				<input type="text" name="password" placeholder="Mot de passe" v-model="password" /></label><br />
			<button>Ajouter</button>
			<div id="user_added">Utilisateur ajouté (ou mis à jour)</div>
		</form>
	</div>
</template>

<script>
import Navbar from "@/components/ui/Navbar";
import axios from "axios";
import {EventBus} from "../../event/event-bus";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	components: {Navbar},
	name: "UserAdmin",
	data() {
		return {
			email_address: "",
			name: "",
			password: "",
			interval_code: 0,
		};
	},
	activated() {
		// EventBus.$on('setLanguage', function () {
		// 	// $this.getDatas($this.id);
		// });
		document.getElementById("user_added").classList.remove("visible");
	},
	created() {
		let $this = this;
		let user_added = document.getElementById("user_added");
		if (user_added) {
			user_added.classList.remove("visible");
		}
	},
	methods: {
		add_user(evt) {
			let $this = this;
			let data = new FormData();
			data.append("email_address", this.email_address);
			data.append("name", this.name);
			data.append("password", this.password);

			axios.post(BASE_URL + "/public/api/register", data,
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				}).then(function () {
				$this.email_address = "";
				$this.name = "";
				$this.password = "";
				let user_added = document.getElementById("user_added");
				if (user_added) {
					user_added.classList.remove("visible");
				}
			},
			);
		},
	},
	computed: {}
	,
};
</script>

<style scoped>
#add_user_form {

}

#add_user_form span {
	display: inline-block;
	width: 200px;
	text-align: right;
}

#add_user_form input {
	width: 300px;
}

#user_added {
	display: none;
}

#user_added.visible {
	display: initial;
}
</style>
